var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionMarkCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z",
    fill: "#9B9DA1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1333 9.50073C10.8568 9.97879 10.2451 10.1421 9.76702 9.86561C9.28896 9.58906 9.1256 8.97733 9.40214 8.49927C9.91934 7.60518 10.8885 7 12.0002 7C13.657 7 15.0002 8.34315 15.0002 10C15.0002 11.0977 14.3268 11.994 13.5002 12.5C12.8362 12.9065 13.2502 14 11.9976 14C11.4453 14 10.9976 13.5523 10.9976 13C10.9976 12.9649 10.9994 12.9302 11.0029 12.896C11.0306 12.3672 11.2665 11.9368 11.5232 11.6239C11.7944 11.2935 12.1509 11.0237 12.4235 10.8616C13.9402 9.96 12.0904 8.1154 11.1333 9.50073ZM11.9976 15C11.4453 15 10.9976 15.4477 10.9976 16C10.9976 16.5523 11.4453 17 11.9976 17C12.5498 17 12.9976 16.5523 12.9976 16C12.9976 15.4477 12.5498 15 11.9976 15Z",
    fill: "#9B9DA1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkCircle);
export default __webpack_public_path__ + "static/media/question-mark-circle.6f4944163c5e380f64bc094a39e15349.svg";
export { ForwardRef as ReactComponent };